import { useEffect, useState } from 'react';

import { Button } from 'shared';
import Box from 'shared_DEPRECATED/components/Box';

import { useIsLatestBuildVersion } from 'features/version/utils/version';

import { Tooltip } from 'shared/components/Tooltip';
import { Typography } from 'shared/components/Typography';

export const NewVersionBanner = () => {
  const isLatestVersion = useIsLatestBuildVersion();
  const [shouldShowBanner, setShouldShowBanner] = useState(false);

  useEffect(() => {
    if (isLatestVersion !== undefined) {
      setShouldShowBanner(!isLatestVersion);
    }
  }, [isLatestVersion]);

  return (
    <Box
      style={{
        position: 'fixed',
        top: '-2rem',
        left: '50%',
        zIndex: 3,
        backgroundColor: 'var(--bgCompPrimaryInverse)',
        borderRadius: '0 0 0.5rem 0.5rem',
        textAlign: 'center',
        transitionDuration: '200ms',
        transform: shouldShowBanner
          ? 'translate(0, 2rem)'
          : 'translate(0, -2rem)',
      }}
    >
      <Tooltip
        content={<Typography color="white">Click to update</Typography>}
        positioning={{ placement: 'bottom' }}
        asChild
      >
        <Button
          onClick={() => window.location.reload()}
          variant="plain"
          size="xs"
        >
          <Typography color="white">New version available!</Typography>
        </Button>
      </Tooltip>
    </Box>
  );
};
